export const PAYINHISTORY="PAYINHISTORY"
export const PAYOUTHISTORY="PAYOUTHISTORY"
